import axios from '../../bootstrap';

export function wexMenuTree() {
    return axios.get('/api/admin/wex/menu/tree').then(result => result.data);
}
